import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import globals from '../../config/globals.json'

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState(new URLSearchParams(useLocation().search).get('message') || '');
  const [otp, setOtp] = useState('');
  const [theme, setTheme] = useState(localStorage.getItem('theme') === 'light' ? 'light' : 'dark');
  const { login } = useContext(AuthContext);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const toggleTheme = () => {
    const nextTheme = theme === 'light' ? 'dark' : 'light';
    document.getElementById('theme-css').href = nextTheme === 'light'
      ? 'css/theme-light.css?v=15'
      : 'css/theme-dark.css?v=30';
    localStorage.setItem('theme', nextTheme);
    setTheme(nextTheme);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(username, password, otp);
      navigate(from, { replace: true });
    } catch (error) {
      setMessage("Login failed. Please check your credentials and try again.");
    }
  };

  return (
    <div className="auth-wrapper">
      <button
        type="button"
        className="auth-theme-toggle"
        onClick={toggleTheme}
        title={theme === 'light' ? 'Passa al tema scuro' : 'Passa al tema chiaro'}
        aria-label={theme === 'light' ? 'Passa al tema scuro' : 'Passa al tema chiaro'}
      >
        <span className="material-symbols-outlined" aria-hidden="true">
          {theme === 'light' ? 'dark_mode' : 'light_mode'}
        </span>
      </button>
      <svg aria-hidden="true" focusable="false" width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <filter id="login-dark-logo-filter" colorInterpolationFilters="sRGB">
            <feFlood floodColor="white" result="white" />
            <feComposite in="white" in2="SourceAlpha" operator="in" result="whiteLogo" />
            <feColorMatrix
              in="SourceGraphic"
              values="0 0 0 0 0
                      0 0 0 0 0
                      0 0 0 0 0
                      1 1 1 0 0"
              result="colorMask"
            />
            <feComposite in="SourceGraphic" in2="colorMask" operator="in" result="coloredLogo" />
            <feComposite in="coloredLogo" in2="whiteLogo" operator="over" />
          </filter>
        </defs>
      </svg>
      <div className="container-fluid h-100">
        <div className="row flex-row h-100 bg-white">
          <div className="col-xl-8 col-lg-6 col-md-5 p-0 d-md-block d-lg-block d-sm-none d-none">
            <div className="lavalite-bg" style={{ backgroundImage: 'url("themekit/img/auth/login-bg.jpg")' }}>
              <div className="lavalite-overlay" />
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 col-md-7 my-auto p-0">
            <div className="authentication-form mx-auto">
              <div className="text-center mb-5">
                <a href="/"><img className="auth-logo-white" src={globals.IMAGE_PATH.GENERIC + "/reboot/logo.png"} height={80} alt="reboot" /></a>
              </div>
              <h3>Sign In to reboot</h3>
              <p>Happy to see you again!</p>
              {message && <div className="alert alert-warning">{message}</div>}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <input type="text" className="form-control" name='username' placeholder="Username" required
                    value={username}
                    onChange={(e) => setUsername(e.target.value)} />
                  <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                    person
                  </span>
                </div>
                <div className="form-group">
                  <input type="password" className="form-control" name='password' placeholder="Password" required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)} />
                  <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                    lock
                  </span>
                </div>
                <div className="form-group">
                  <input type="number" className="form-control" name='otp' placeholder="OTP" required
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)} />
                  <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                    dialpad
                  </span>
                </div>
                <div className="row">
                  <div className="col text-left">
                    <label className="custom-control custom-checkbox">
                      <input type="checkbox" className="custom-control-input" id="item_checkbox" name="item_checkbox" defaultValue="option1" />
                      <span className="custom-control-label">&nbsp;Remember Me</span>
                    </label>
                  </div>
                  <div className="col text-right">
                    {/* <a href="/">Forgot Password ?</a> */}
                  </div>
                </div>
                <div className="sign-btn text-center">
                  <button className="btn btn-theme">Sign In</button>
                </div>
              </form>
              <div className="register">
                {/* <p>Don't have an account? <a href="mailto: info@dixxip.com">Contact us</a></p> */}
                <p>Don't have an account? Contact us</p>
                <a href="//dixxip.com" target='_blank'><img className="auth-logo-white-ink" src={globals.IMAGE_PATH.GENERIC + "/logo-black.png"} height={50} alt="dixxip_logo" /></a>
                <p className="mt-2">© {new Date().getFullYear()} dixxip.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;